import { useQuery } from "@tanstack/react-query";
import statsSAService from "services/superadmin/statsSAService";

export const useGetNewDevicesCountByMonths = (queryParams = {}) => {
    return useQuery({
        queryKey: ['newDevicesCountByMonths', queryParams],
        queryFn: async () => {
            const { data } = await statsSAService.getNewDevicesByMonths(queryParams)
            return data
        },
        refetchOnWindowFocus: false,
    })
}